<!--日历-->

<template>
  <div>AttrCalendar</div>
</template>

<script>
export default {
  name: "AttrCountdown",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  mounted() {
    console.log(this.media);
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
</style>